import { ApiService } from "../../../../../core";
import { FormRecoveryController, SignupResponse } from "../../core";

export class FormRecoveryControllerImpl implements FormRecoveryController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<string> {
        try {
            const response: string = await this.api.get(`/signup`);
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async requestRecoveryAccess(formData: FormData): Promise<string | null> {
        try {
            const response: SignupResponse = await this.api.post(`/recovery-access-request`, formData);

            return response.response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async recoveryCodeValidate(formData: FormData): Promise<SignupResponse> {
        try {
            const response: SignupResponse = await this.api.post(`/recovery-access-validade`, formData);

            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async recoveryNewPassword(formData: FormData): Promise<SignupResponse> {
        try {
            const response: SignupResponse = await this.api.post(`/recovery-access-new-password`, formData);

            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}